module.exports = __webpack_public_path__ + "assets/3cfc4754fa6f59ad47dc0cb33aabb0aa.svg";